import { hasClaimNumbers } from './helper'

const initialState = {
  isGetClaimNumbersLoading: false,
  claimNumbers: {},
}

export default function (state = initialState, action = {}) {
  switch (action.type) {

    case 'GET_CLAIM_NUMBERS': {
      return {
        ...state,
        isGetClaimNumbersLoading: true,
      }
    }
    case 'GET_CLAIM_NUMBERS_COMMIT': {
      return {
        ...state,
        isGetClaimNumbersLoading: false,
        claimNumbers: hasClaimNumbers(action.payload) ? action.payload : {},
      }
    }
    case 'GET_CLAIM_NUMBERS_ROLLBACK': {
      return {
        ...state,
        isGetClaimNumbersLoading: false,
      }
    }

    default: {
      return state
    }
  }
}
